<template>
    <!--友情链接-->
    <section class="friendship wow animate__animated animate__fadeInUp" data-wow-duration="2s">
        <div class="friendship-title work-text work-text-two nrk"  v-if="!switchoff">
            <p>
                <i>友情链接</i>
                <span>FPIENDLYLINK</span>
                <em class="geng">
                    <router-link :to="{name:'Links'}">更多></router-link>
                </em>
            </p>
        </div>
        <ul class="friendship-content nrk">
            <li v-for="item in Link" :key="item.id">
                <a :href="item.href">
                    <div></div>
                    <p>{{item.name}}</p>
                </a>
            </li>
        </ul>
    </section>
</template>

<script>
import{mapState} from'vuex';
export default {
    props:['switchoff'],
    computed:{
        ...mapState({
            Link:state=>state.share.Link,
        })
    },
}
</script>
    
<style scoped>
    .friendship-title{
        margin-top: 40px;
    }
    .geng{
        float:right;
        line-height: 38px;
        margin-right: 5%;
        color: #666;
        font-size: 13px;
    }
    .friendship-content{
        margin: 20 auto;
        overflow: hidden;
    }
    .friendship-content li{
        width: 21.6%;
        margin-right: 4%;
        height: 50px;
        border: 1px #d1d1d1 solid;
        border-radius: 50px;
        line-height: 50px;
        float: left;
        margin-top: 40px;
    }
    .friendship-content li div{
        width: 50px;
        height: 50px;
        float: left;
        background: url(./img/xt_3.png) no-repeat;
        background-size: 100%;
    }
    .friendship-content li p{
        width: 82%;
        text-align: center;
        float: left;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        font-size: 16px;
        -webkit-box-orient: vertical;
    }
    .friendship-content li:nth-child(4n){
        margin-right: 0;
    }
    .work-text {
        margin: 0 auto;
        margin-top: 120px;
    }

    .work-text i {
        font-size: 38px;
        font-weight: bold;
        color: #333;
    }

    .work-text span {
        font-size: 24px;
        color: #333;
        margin-left: 25px;
    }

    .work-img {
        width: 100%;
        margin-top: 53px;
    }

    .work-img li {
        width: 25%;
        float: left;
        text-align: center;
        margin-bottom: 94px;
    }

    .work-img li img {
        padding: 24px;
        border: 2px #333 solid;
        border-radius: 50px;
    }

    .work-img li p {
        margin-top: 40px;
        color: #333;
        font-size: 18px;
        letter-spacing: 1px;
    }
    @media (max-width: 768px){
        .friendship-content li{
            width: 100%;
            margin-top: 12px;
        }
        .work-img{
            margin-top: 10%;
        }
        .work-text i{
            font-size: 24px;
        }
        .work-text span{
            font-size: 12px;
        }
        .work-text img{
            width: 70%;
        }
        .work-text {
            margin-top: 10%;
        }
        .work-img li img{
            padding: 10px;
            width: 50%;
        }
        .work-img li p{
            margin-top: 8px;
            font-size: 12px;
        }
        .work-img li{
            margin-bottom: 8%;
        }
    }
</style>